import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";

const PoolCancelRequests = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [recall, setRecall] = React.useState(false);
    const [filters, setFilters] = useState({
        poolId: new URLSearchParams(history?.location?.search)?.get("poolId") || undefined
    });

    const [loading, cancelRequests] = useFetch({
        fetchFn: stores.poolShiftStore.getCancelRequests.bind(null, {
            limit: 10,
            page: currentPage,
            poolId: filters?.poolId
        }),
        dependencies: [JSON.stringify(filters), currentPage, recall]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            {/*    <Row justify="end">
                <ActionButtons />
            </Row> */}
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={cancelRequests?.data?.rows || []}
                    dataCount={cancelRequests?.data?.dataCount || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    recall={() => setRecall(!recall)}
                />
            </Row>
        </div>
    );
};

export default PoolCancelRequests;
